<template>
  <v-container>
    <jobEnviaDadosWsRestGrid v-if="grid" @editItem="editItem" />
    <jobEnviaDadosWsRestForm v-else :tenantUpdating="tenant" @editItem="editItem" />
  </v-container>
</template>

<script>
import jobEnviaDadosWsRestGrid from './grid'
import jobEnviaDadosWsRestForm from './form'

export default {
  name: 'JobEnviaDadosWsRest',

  data: () => ({
    grid: true,
    tenant: ''
  }),

  components: {
    jobEnviaDadosWsRestGrid,
    jobEnviaDadosWsRestForm
  },

  methods: {
    editItem (boolean, item) {
      this.grid = boolean
      this.tenant = item?.jobIdentifier
    }
  }
}
</script>
